var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9634 8.66667C13.9876 8.4478 14 8.22533 14 8C14 4.68629 11.3137 2 8 2C6.11515 2 4.43331 2.86911 3.33333 4.22845M2.03662 7.33333C2.01242 7.5522 2 7.77467 2 8C2 11.3137 4.68629 14 8 14C9.88487 14 11.5667 13.1309 12.6667 11.7715",
    stroke: "#2E2C27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 4.66667H4.66675C3.72394 4.66667 3.25253 4.66667 2.95964 4.37377C2.66675 4.08088 2.66675 3.60947 2.66675 2.66667V2",
    stroke: "#2E2C27",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 11.3334H11.3334C12.2762 11.3334 12.7476 11.3334 13.0405 11.6262C13.3334 11.9192 13.3334 12.3906 13.3334 13.3334V14",
    stroke: "#2E2C27",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.70882dc99844d11c7e1724a2fdb1a789.svg";
export { ForwardRef as ReactComponent };